<template>
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 lbl">
          <label>Entité :</label>
        </div>
        <div class="col">
          <Dropdown class="dropdown-height"
                    v-model="entite"
                    :options="entiteLibelles"
                    optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px"
                    :showClear="true"/>
        </div>
      </div>
      <div class="row">
          <div class="col-4 lbl">
              <label>Genre :</label>
          </div>
          <div class="col">
              <Dropdown class="dropdown-height"
                        v-model="genre"
                        :options="genreLibelles"
                        optionValue="valeur"
                        optionLabel="texte"
                        scrollHeight="205px"
                        :showClear="true"/>
          </div>
      </div>
      <div class="row">
          <div class="col-4 lbl">
              <label>Nature :</label>
          </div>
          <div class="col">
              <Dropdown v-model="nature"
                        :options="natureLibelles"
                        optionValue="valeur"
                        optionLabel="texte"
                        @:keyup.enter="rechercher"
                        scrollHeight="205px"
                        :showClear="true"/>
          </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="effacerCriteres"> Effacer critères </Button>
    </div>
    <div class="col" >
      <Button @click="ajouterType"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>

export default {
  name: "CriteresRechercheType",
  emits: ['rechercher', 'fermer'],
  data() {
    return {
      entite: null,
      genre: null,
      nature: null,
      type: null,
      entiteLibelles: [],
      genreLibelles: [],
      natureLibelles: [],
      typeLibelles: [],
      critereRechercheClassementDossier: {},
    }
  },
  beforeMount() {
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
          this.assignerListe(res.data.entiteDecision);
        });
    this.entite = Number(this.$route.params.entite);
    if (this.$route.params.genre !== null && this.$route.params.genre !== undefined) {
      this.genre = Number(this.$route.params.genre);
    }
    if (this.$route.params.nature !== null && this.$route.params.nature !== undefined) {
      this.nature = Number(this.$route.params.nature);
    }
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles
    },
    rechercher(){
        let libelleRecherche = {};
        libelleRecherche.valeur = this.entite;
        libelleRecherche.enfant = {};
        libelleRecherche.enfant.valeur = this.genre;
        libelleRecherche.enfant.enfant = {};
        libelleRecherche.enfant.enfant.valeur = this.nature;
        libelleRecherche.enfant.enfant.enfant = {};
        libelleRecherche.enfant.enfant.enfant.texte = this.type;
        libelleRecherche.enfant.enfant.enfant.code = 'Type';
        this.$emit('rechercher', libelleRecherche);
    },
      rechercherType() {
          this.critereRechercheClassementDossier.entite = this.entite;
          this.critereRechercheClassementDossier.genre = this.genre;
          this.critereRechercheClassementDossier.nature = this.nature;
          this.critereRechercheClassementDossier.type = this.type;
          this.$emit('rechercherType', this.critereRechercheClassementDossier);
      },
      effacerCriteres() {
      this.genre = null;
      this.nature = null;
      this.type = null;
      this.entite = null;
    },
    ajouterType() {
      this.$router.push({name: "ajouterType",params:{entite: this.entite}});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        }).then((res) => {
          this.genreLibelles = res.data;
        });
      } else {
        this.genre = null;
        this.genreLibelles = [];
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        }).then((res) => {
          this.natureLibelles = res.data;
        });
      } else {
        this.nature = null;
        this.natureLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        }).then((res) => {
          this.typeLibelles = res.data;
        });
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
  }
}
</script>
